import React, { useMemo } from 'react';
import { rootDisplayActions } from 'app/reducers/display/slice';
import ModalContainer from 'design-v2/common/ModalContainer';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { useAppDispatch } from 'appRoot/Store';
import BookingButtons from 'app/common/BookingButtons';
import { Box, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ActionButton from 'design-v2/common/ActionButton';
import { floorplanBookingsActions } from 'floorplan-v2/app/reducers/bookings/slice';
import BookingCardContainer from 'booking-card-list/BookingCardContainer/BookingCardContainer';
import { IBooking } from 'shared-types/SharedTypes';
import color from 'design-v2/globals/colors/colors.module.css';
import styles from './style.module.scss';
import GreyDivider from 'app/common/Divider/GreyDivider';
import BookingService from 'app/services/booking/booking.service';

const SharedTableModal = () => {
  const dispatch = useAppDispatch();
  const showSharedTableModal = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showSharedTableModal);
  const {bookings, table} = useSelector((state: DiaryRootState) => state.rootDisplayReducer.sharedTableModalPayload);

  const handleClose = () => {
    dispatch(rootDisplayActions.setShowSharedTableModal(false));
  };

  const _handleBookingClicked = (activeBooking: IBooking) => {
      handleClose();
    BookingService.handleModalBookingClicked(activeBooking, dispatch);
    }

  const handleStatusChange = (bookingId: string, statusId: string) => {
    dispatch(
      floorplanBookingsActions.setSelectedBookingForStatusModal({
        statusId,
        bookingId,
      })
    );
  };

  if (!showSharedTableModal) {
    return null;
  }


  return (
    <ModalContainer
      isOpen={showSharedTableModal}
      onRequestClose={handleClose}
    >
      <Box className={styles.modalContent}>
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title}>
            Shared table - {table?.name}
          </Typography>
          <IconButton size="medium" aria-label="Close shared table" onClick={handleClose} >
            <CloseIcon className={color.clrGreyMedium} />
          </IconButton>
        </Box>

        {/* Action Buttons -- New booking and Walk in */}
        <Box className={styles.actionButtons}>
          <BookingButtons table={table} onNewBookingClicked={handleClose}/>
        </Box>

        {/* Booking List */}
        <Box className={styles.bookingList}>
          {bookings && bookings.map((booking, index) =>

            <Box key={booking._id}>
              <BookingCardContainer
                booking={booking}
                handleBookingStatusClicked={({statusId, bookingId}) => handleStatusChange(bookingId, statusId)}
                handleBookingClicked={() => _handleBookingClicked(booking)}
              />

              <GreyDivider />

            </Box>
          )}
        </Box>

        {/* Done Button */}
        <Box className={styles.doneButtonContainer}>
          <ActionButton variant={'primary'} size={'regular'} text={'Done'} handleClick={handleClose} />
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default SharedTableModal;
